export default __webpack_public_path__ + "static/1201-d7e65400c33be0881b187431c15469d9.gif";